/**
 * Nextdoor Functions
 *
 * @see https://developer.nextdoor.com/reference/for-net-new-advertisers
 * @see https://developer.nextdoor.com/reference/conversion-api
 */

(function (pmw, undefined) {

	/**
	 * User matching data for advanced matching, shared by the browser pixel
	 * init call and the Conversion API events.
	 *
	 * @return {object}
	 */
	pmw.getNextdoorCustomerData = () => {

		const customer = {};

		if (pmwDataLayer?.pixels?.nextdoor?.advanced_matching) {

			if (pmwDataLayer?.user?.email?.sha256) {
				customer.email = pmwDataLayer.user.email.sha256;
			}

			if (pmwDataLayer?.user?.id?.sha256) {
				customer.external_id = pmwDataLayer.user.id.sha256;
			}
		}

		return customer;
	};

	/**
	 * Resolve the Nextdoor click ID (ndclid).
	 *
	 * Priority (mirrors the PHP side in Nextdoor_CAPI):
	 * 1. The ndclid first-party cookie the Nextdoor Universal Pixel (ndp.js)
	 *    writes on the landing page.
	 * 2. Fallback: PMW's own capture of the ndclid URL parameter
	 *    (event_listeners.js), because the pixel cookie is absent when the
	 *    pixel never ran on the landing page.
	 *
	 * @return {string|undefined}
	 */
	pmw.getNextdoorClickId = () => {
		return pmw.getCookie("ndclid") || pmw.retrieveData("ndclid");
	};

	/**
	 * Load the Nextdoor Universal Pixel
	 *
	 * Injects the standard Nextdoor base code snippet. The snippet defines
	 * window.ndp as a queueing function immediately, so API calls made right
	 * after this still work. The pixel is initialized with the pixel ID; the
	 * PAGE_VIEW event is sent through the unified event system so the browser
	 * pixel and the Conversion API share one event ID for deduplication.
	 */
	pmw.loadNextdoorPixel = () => {
		try {
			// @formatter:off
			(function (win, doc, sdk_url) {
				if (win.ndp) return;
				var tr = win.ndp = function () {
					tr.handleRequest ? tr.handleRequest.apply(tr, arguments) : tr.queue.push(arguments);
				};
				tr.queue = [];
				var s = "script";
				var new_script_section = doc.createElement(s);
				new_script_section.async = !0;
				new_script_section.src = sdk_url;
				var insert_pos = doc.getElementsByTagName(s)[0];
				insert_pos.parentNode.insertBefore(new_script_section, insert_pos);
			})(window, document, "https://ads.nextdoor.com/public/pixel/ndp.js?id=" + pmwDataLayer.pixels.nextdoor.pixel_id);
			// @formatter:on

			const initData = {};

			// With advanced matching enabled, send the SHA-256 hashed email of
			// logged-in customers and purchasers to improve match rates.
			const customer = pmw.getNextdoorCustomerData();
			if (customer.email) {
				initData.user_email_hash = customer.email;
			}

			// Initialize with the pixel ID
			window.ndp("init", pmwDataLayer.pixels.nextdoor.pixel_id, initData);

			pmwDataLayer.pixels.nextdoor.loaded = true;

			pmw.console.log("Nextdoor: pixel loaded");

		} catch (e) {
			console.error(e);
		}
	};

	/**
	 * Send an event to the Nextdoor Universal Pixel
	 *
	 * The pixel_ids and event_id event parameters and the custom data object
	 * mirror the arguments of Nextdoor's official tag manager templates. The
	 * event_id matches the Conversion API event so Nextdoor deduplicates the
	 * browser pixel and the server event.
	 *
	 * The adapter carries the custom data in the Conversion API shape (plain
	 * order_value plus a separate currency field); the browser pixel expects
	 * the concatenated order_value form ("USD412.21"), so it is converted here.
	 *
	 * @param {Object} nextdoorData - Adapted Nextdoor event from the event payload
	 */
	pmw.nextdoorTrackEvent = (nextdoorData) => {
		try {
			if (typeof window.ndp !== "function") return;
			if (!nextdoorData?.event_name) return;

			const eventParams = {pixel_ids: [pmwDataLayer.pixels.nextdoor.pixel_id]};

			if (nextdoorData.event_id) {
				eventParams.event_id = nextdoorData.event_id;
			}

			const customData = {...(nextdoorData.custom_data || {})};

			if (customData.order_value && customData.currency) {
				customData.order_value = customData.currency + customData.order_value;
				delete customData.currency;
			}

			window.ndp("track", nextdoorData.event_name, eventParams, customData);

			pmw.console.log("Nextdoor: " + nextdoorData.event_name + " event sent", nextdoorData);

		} catch (e) {
			console.error(e);
		}
	};

}(window.pmw = window.pmw || {}));
